import { useRef, useCallback } from 'react';

/**
 * Hook to manage pagination with automatic scroll-to-top behavior.
 * Returns a ref for the scrollable container and a handler for page changes.
 */
export const useScrollablePagination = <T extends HTMLElement = HTMLDivElement>() => {
    const scrollContainerRef = useRef<T>(null);

    const scrollToTop = useCallback(() => {
        scrollContainerRef.current?.scrollTo({ top: 0, behavior: 'smooth' });
    }, []);

    return {
        scrollContainerRef,
        scrollToTop,
    };
};

